namespace('compass.hotel');


compass.hotel.HotelSmallImageWidget = compass.defineWidget(function HotelSmallImageWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;
	var _animationRunning = false;
	var _slideWidth = 0;
    var _defaultImage = compass.staticPrefix + "/resources/img/compass/hotel/nomainimage.jpg";


	var _setupControls = function() {

	};

	this.render = function(widgetElem) {
		var d = _d;
		var defaultImage = _.find(_settings.imgs, function(img) { return img.main_image === true; } );
		imgUrl = defaultImage ? defaultImage.link : _defaultImage;
		widgetElem.append(
			d.div({ className : 'imagesWrapper' }, 
				d.img({ className : 'hotelImg', src : imgUrl })
			)
		);

		_setupControls();
	};

	this.destroyWidget = function(){
		jQuery(".imagesWrapper").remove();
	};
	
	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'defaultHotelSmallImageWidgetWUID',
	widgetName : 'HotelSmallImageWidget',
	imgPath : '/resources/img',
	subclass : false,
	imgs : []
});

